import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip, Button } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';

const DeleteButton = (props) => {
  return (
    <Tooltip title="Delete">
      <Button
        data-cy={`delete-button${props.id}`}
        onClick={props.onClick}
        className="deleteButton"
        variant="contained"
        style={{ textTransform: 'none' }}
        size="small"
      >
        <DeleteOutline />
      </Button>
    </Tooltip>
  );
};

DeleteButton.propTypes = {
  id: PropTypes.string,
  onClick: PropTypes.func,
};

export default DeleteButton;
